import React from "react";
import DataTable from "../../../components/DataTable";

const FeeHeads = () => (
  <DataTable
    title="Fee Heads"
    apiPath="/api/admin/master/fee-heads"
    columns={[
      { key: "id", label: "ID" },
      { key: "name", label: "Name" },
    ]}
    formFields={[
      { key: "name", label: "Fee Head Name", required: true },
    ]}
  />
);

export default FeeHeads;
